import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"; //TE for data persistence start
import {
  saveSelfAssessment,
  clearSelfAssessment,
} from "stores/modules/cap/selfassessmentreducer"; //TE for data persistence end

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import QuizIcon from "@mui/icons-material/Quiz";

import "../../styles/cap.css";

import {
  fetchStandardOptions as fetchStandardOptionsService,
  fetchAssessmentReportdetailsByAssessmentId as fetchAssessmentDetailsByIDService,
  fetchControlsByCompanyStandardId as fetchControlsByCompanyStandardIdService,
  fetchSubControlsByCompanyStandardControl as fetchSubControlsByCompanyStandardControlService,
  submitAssessmentReport as submitAssessmentService,
  fetchStandardsByStandard as fetchAllStandardsService,
} from "services/modules/cap/standardservice";
import {
  putAssessmentStatus as updateAssessmentService,
  uploadSelfAssessmentEvidence as uploadSelfAssessmentEvidenceService,
} from "services/modules/cap/assessmentservice";
import { GrCompliance } from "react-icons/gr";

import LoadingOverlay from "components/LoadingOverlay.jsx";
import { useNotification } from "config/Notification";
import { blueGrey } from "@mui/material/colors";

// US-CAP-104: Type-aware answer renderer
import QuestionRenderer, {
  mapAnswerToSeverity,
} from "../shared/QuestionRenderer";

const SelfAssessmentPage = () => {
  // useLOcation hook
  const location = useLocation();

  // React router
  const navigate = useNavigate();

  // Query params
  const urlparams = location.state;

  // Notification
  const { openNotification } = useNotification();

  // State variables
  //const [mit1, setMit1] = useState([]); //TE for data persistence to delete this line I made it as comment
  const [heading, setHeading] = useState("");
  const [questionTitle, setQuestionTitle] = useState("");
  const [safeguards, setSafeguards] = useState([]);
  const [question, setQuestion] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [isNotValidControl, setIsNotValidControl] = useState(false);
  const [assementsList, setAssementsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialog, setDialog] = useState(false);
  const [user] = useState({
    collection: [],
    safeguardCollections: [],
  });
  const [isReject, setIsReject] = useState(false);
  const [allControls, setAllControls] = useState([]);
  const [isPrevvalueButton, setIsPrevvalueButton] = useState(true);
  const [isSaveButton, setIsSaveButton] = useState(false);
  const [isNextValueButton, setIsNextValueButton] = useState(false);
  const [standardType, setStandardType] = useState("");
  const [standardId, setStandardId] = useState("");
  const [standardOptions, setStandardOptions] = useState(null);
  const selectedCompanyContainer = useSelector(
    (state) => state.auth.companyData,
  );
  const dispatch = useDispatch(); //TE for data persistence
  // const assessmentStore = useSelector((state) => state.capSelfAssessment.answers); //TE for data persistence //TE for Proper data storage commented prev code for the following code
  //TE for Proper Data Store start
  const assessmentStore = useSelector((state) => {
    const assessmentId = location.state?.assessmentid;
    return state.capSelfAssessment.assessments?.[assessmentId]?.answers || {};
  });
  //TE for Proper Data store end

  const [assessmentStatus, setAssessmentStatus] = useState("");
  const [rejectionSummary, setRejectionSummary] = useState("");
  // US-CAP-301: Due-date hold state
  const [dueDate, setDueDate] = useState(null);
  const isOnHold = assessmentStatus === "On Hold";

  // useEffect hook fetches groupnames by standard and assessment details by assessment id
  useEffect(() => {
    getGroupNameByStandard(urlparams.standard);
    getAssessmentDetailsByAssessmentId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetches standards based on standard type and sets the controls and questions
  const getAllControlsByStandardCompany = async () => {
    try {
      const standard = standardId;
      const companyId = selectedCompanyContainer.companyid;
      const params = { Standard: standard, company: companyId };
      const response = await fetchControlsByCompanyStandardIdService(params);

      if (response.status === 200) {
        let array = [];
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].ControlID) {
            array.push(response.data[i].ControlID);
          }
        }
        array = removeDuplicates(array);
        setAllControls(array);
        setTotalQuestions(array.length);
      }
    } catch (error) {
      openNotification("Error while fetching controls");
    }
  };

  const getStandardOptions = async () => {
    try {
      const params = { standard_code: standardId };
      const response = await fetchStandardOptionsService(params);

      const options = response?.data?.data?.options || {
        "Not Applicable": 0,
        "Not Implemented": 1,
        "Partially Implemented": 2,
        "Largely Implemented": 3,
        "Fully Implemented": 4,
      };

      setStandardOptions(options);
    } catch (error) {
      // fallback if API missing
      setStandardOptions({
        "Not Applicable": 0,
        "Not Implemented": 1,
        "Partially Implemented": 2,
        "Largely Implemented": 3,
        "Fully Implemented": 4,
      });
    }
  };
  //code change end

  // useEffect hook fetches all controls based on whether standard is a main standard or domain standard
  useEffect(() => {
    if (standardId) {
      getAllControlsByStandardCompany();
      getStandardOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standardId]);

  // useEffect hook fetches the latest controls
  useEffect(() => {
    if (allControls.length > 0) {
      getLatestControl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allControls]);

  useEffect(() => {
    getstorevalues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safeguards]);

  // Fetches group names based on standard
  const getGroupNameByStandard = async (standard) => {
    try {
      const company = selectedCompanyContainer?.companyid;
      let standardResponse = await fetchAllStandardsService({
        name: standard,
        company,
      });
      if (standardResponse.status === 200) {
        const standardid = standardResponse?.data[0]?.stdid;
        setStandardId(standardid);
        const group = standardResponse?.data[0]?.group;
        setStandardType(group);
      }
    } catch (error) {
      openNotification("Server error", "error");
    }
  };

  const spanActive = (id, tag, index, color) => {
    const scclass = "standardoptionactive";
    const maindiv = "main" + id;
    const presentdiv = parseInt(index) + 1;

    // Cache DOM elements
    // const currentSpan = document.getElementById(id).getElementsByClassName(tag)[0];
    const parent = document.getElementById(id);

    if (!parent) return;

    const currentSpan = parent.getElementsByClassName(tag)[0];

    if (!currentSpan) {
      return;
    }
    const mainDiv = document.getElementById(maindiv);
    const numberDiv = mainDiv.getElementsByClassName("number")[0];

    // If there is a next item in the list, mark it as present
    if (presentdiv < safeguards.length) {
      document
        .getElementById("fixeddiv")
        .getElementsByClassName("number")
        [presentdiv].classList.add("present");
    }

    // Check if an element is already active and remove previous active classes
    const activeElement = document
      .getElementById(id)
      .getElementsByClassName("active")[0];
    if (activeElement) {
      // Remove all active classes
      [
        "naactive",
        "niactive",
        "piactive",
        "liactive",
        "fiactive",
        "active",
        "standardoptionactive",
      ].forEach((className) => {
        activeElement.classList.remove(className);
        activeElement.style.backgroundColor = "";
      });
    }

    // Add active class to the current span
    currentSpan.classList.add("active", scclass);

    //  Add background color dynamically based on the class
    // const backgroundColor = colorMapping[scclass] || "#f0f0f0"; // Default color if no match
    currentSpan.style.backgroundColor = color;

    // Mark the current item as completed
    numberDiv.classList.add("completed");

    // Update the user's collection with the active span's name
    user.collection[id] = currentSpan.getAttribute("name");

    // Call the mitigationplus function (assumed to be defined elsewhere)
    mitigationplus(id);
    //TE for Proper data store following block of code commented for follow code
    // dispatch(            //TE for data persistence start
    //   saveSelfAssessment({
    //     subcontrolId: id,
    //     field: "severity",
    //     value: currentSpan.getAttribute("name"),
    //   })
    // );                  //TE for data persistence end

    //TE for Proper data store start
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: id,
        field: "severity",
        value: currentSpan.getAttribute("name"),
      }),
    );
    // US-CAP-104: Also store answer_value and question_type for new scoring engine
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: id,
        field: "answer_value",
        value: currentSpan.getAttribute("name"),
      }),
    );
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: id,
        field: "question_type",
        value: "five_option",
      }),
    );
    //TE for Proper data store end
  };

  // Expands Rational textbox by clicking on plus
  const mitigationplus = (id) => {
    const mitigationElement = document.getElementById("mitigation" + id);
    if (mitigationElement) {
      const mitigationMinus = mitigationElement.getElementsByClassName(
        "mitigationminus",
      )[0];
      const mitigationTextarea = mitigationElement.getElementsByClassName(
        "mitigationtextarea",
      )[0];
      const mitigationPlus = mitigationElement.getElementsByClassName(
        "mitigationplus",
      )[0];

      if (mitigationMinus && mitigationTextarea && mitigationPlus) {
        mitigationMinus.style.display = "block";
        mitigationTextarea.style.display = "block";
        mitigationPlus.style.display = "none";
      }
    }
  };

  // Minimises Rational textbox by clicking on minus
  const mitigationminus = (id) => {
    const mitigationElement = document.getElementById("mitigation" + id);
    if (mitigationElement) {
      const mitigationMinus = mitigationElement.getElementsByClassName(
        "mitigationminus",
      )[0];
      const mitigationTextarea = mitigationElement.getElementsByClassName(
        "mitigationtextarea",
      )[0];
      const mitigationPlus = mitigationElement.getElementsByClassName(
        "mitigationplus",
      )[0];

      if (mitigationMinus && mitigationTextarea && mitigationPlus) {
        mitigationMinus.style.display = "none";
        mitigationTextarea.style.display = "none";
        mitigationPlus.style.display = "block";
      }
    }
  };

  // Handles displaying the reject remarks while retaking the assessment and stores the new response
  const getstorevalues = () => {
    setLoading(true);

    for (let t = 0; t < safeguards.length; t++) {
      const safeguardId = safeguards[t].id;

      // Restore severity from Redux store into user.collection
      const reduxSeverity = assessmentStore[safeguardId]?.severity;
      if (reduxSeverity) {
        user.collection[safeguardId] = reduxSeverity;
      }

      const qType =
        assessmentStore[safeguardId]?.question_type || "five_option";

      if (user.collection[safeguardId]) {
        // FIX: Only call spanActive for five_option.
        // yes_no / checkbox / radio / text_box are controlled by React via
        // assessmentStore, so spanActive is not needed and would break them.
        if (qType === "five_option") {
          const tag = user.collection[safeguardId];
          const index = t + 1;
          const severity = standardOptions?.[tag];

          let color;
          switch (severity) {
            case 0:
              color = "#333333";
              break;
            case 1:
              color = "#B60000";
              break;
            case 2:
              color = "#BF9D12";
              break;
            case 3:
              color = "#50E232";
              break;
            case 4:
              color = "#227C10";
              break;
            default:
              color = "#000000";
          }

          spanActive(safeguardId, tag.trim().toLowerCase(), index, color);
        }
        // For all other types, QuestionRenderer reads from assessmentStore directly.
        // No DOM manipulation needed.
      }

      if (assementsList.length > 0) {
        assementsList.forEach((e) => {
          if (e.subcontrol === safeguardId) {
            if (e.assessment_comments !== undefined) {
              setIsReject(true);

              const index = safeguards.findIndex(
                (item) => item.id === safeguardId,
              );
              if (index === -1) return;

              const updatedData = [...safeguards];
              updatedData[index] = {
                ...updatedData[index],
                assessment_comments: e.assessment_comments,
              };
              setSafeguards(updatedData);
            }
          }
        });
      }
    }

    setLoading(false);
  };
  //                             //TE for data persistence end
  // Handles navigation to previous step and fetches controls and safeguards for that particular step

  const Prev = async () => {
    setIsNotValidControl(false);

    let nextVal = parseInt(document.getElementById("nextvalue").value);
    let id = nextVal - 2;

    if (id < 0) {
      return;
    }

    await getAssessmentDetailsByAssessmentId();
    await getControls(id);
    await getSafeguards(id);

    window.scrollTo(0, 200);
  };
  //code change end

  // Handles navigation to previous step and fetches controls and safeguards for that particular step
  const Next = async () => {
    await getAssessmentDetailsByAssessmentId();
    let id = parseInt(document.getElementById("nextvalue").value);
    await getControls(id);
    await getSafeguards(id);
    window.scrollTo(0, 200);
  };

  // Fetches assessment details by asssessment id and sets assessment list if user has saved responses
  const getAssessmentDetailsByAssessmentId = async () => {
    setLoading(true);
    try {
      let response = await fetchAssessmentDetailsByIDService({
        assessmentid: urlparams.assessmentid,
      });

      let assessmentData = [];

      if (Array.isArray(response?.data)) {
        assessmentData = response.data;
      } else {
        assessmentData = response?.data?.controls || [];
        setAssessmentStatus(response?.data?.status || "");
        setRejectionSummary(response?.data?.overall_rejection_remarks || "");
        setDueDate(response?.data?.due_date || null);
      }

      if (assessmentData.length > 0) {
        setAssementsList(assessmentData);

        assessmentData.forEach((e) => {
          // Always keep user.collection for five_option DOM compat
          user.collection[e.subcontrol] = e.severity;

          // FIX: Restore ALL question types into Redux so QuestionRenderer
          // can display yes_no, checkbox, radio, text_box answers correctly
          const qType = e.question_type || "five_option";
          const answerValue = e.answer_value || e.severity;

          dispatch(
            saveSelfAssessment({
              assessmentId: urlparams.assessmentid,
              subcontrolId: e.subcontrol,
              field: "severity",
              value: e.severity,
            }),
          );
          dispatch(
            saveSelfAssessment({
              assessmentId: urlparams.assessmentid,
              subcontrolId: e.subcontrol,
              field: "answer_value",
              value: answerValue,
            }),
          );
          dispatch(
            saveSelfAssessment({
              assessmentId: urlparams.assessmentid,
              subcontrolId: e.subcontrol,
              field: "question_type",
              value: qType,
            }),
          );
          dispatch(
            saveSelfAssessment({
              assessmentId: urlparams.assessmentid,
              subcontrolId: e.subcontrol,
              field: "rationale",
              value: e.rational || "",
            }),
          );
          // US-CAP-302: Restore previously uploaded evidence so it shows up
          // (and counts toward the mandatory-evidence check) without re-upload.
          dispatch(
            saveSelfAssessment({
              assessmentId: urlparams.assessmentid,
              subcontrolId: e.subcontrol,
              field: "evidence",
              value: e.evidence_files || [],
            }),
          );
        });
      }

      setLoading(false);
    } catch (error) {
      openNotification("Error fetching assessment details:", "error");
      setLoading(false);
    }
  };
  // Enables and disables previous,next and submit buttons based on control id and fetches standards based on standard type
  const getControls = async (id) => {
    setLoading(true);
    try {
      if (id === 0) {
        setIsPrevvalueButton(false);
      } else {
        setIsPrevvalueButton(true);
      }

      if (id === parseInt(totalQuestions) - parseInt(1)) {
        setIsSaveButton(true);
        setIsNextValueButton(false);
      } else {
        setIsSaveButton(false);
        setIsNextValueButton(true);
      }
      setQuestion(parseInt(id));
      let controlId = allControls[id];

      let response = "";
      const standard = standardId;
      const companyId = selectedCompanyContainer.companyid;
      let params = {
        Standard: standard,
        company: companyId,
        ControlID: controlId,
      };
      // params.ControlID = controlId;
      response = await fetchControlsByCompanyStandardIdService(params);

      if (standardType === "Main Standard") {
        if (response.status === 200) {
          for (let z = 0; z < response.data.length; z++) {
            setQuestionTitle(response.data[z].Title);
          }
        }
      } else if (standardType === "Domain Standard") {
        if (response.status === 200) {
          for (let z = 0; z < response.data.length; z++) {
            setQuestionTitle(response.data[z].Title);
            setHeading(response.data[z].Title);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // Handles saving all the responses in a stepwise manner
  const saveStepByStep = async () => {
    setLoading(true);
    setIsNotValidControl(false);

    const applicableSubControls = [];
    let valid = true;

    for (let i = 0; i < safeguards.length; i++) {
      const item = safeguards[i];
      const stored = assessmentStore[item.id];

      // Check severity/answer is filled (Redux first, then DOM fallback)
      const severity = stored?.severity || user.collection[item.id];

      if (!severity) {
        valid = false;
        const subEl = document.getElementById("sub" + item.id);
        const iconEl = document.getElementById("sub-icon" + item.id);
        if (subEl) subEl.style.border = "solid 1px red";
        if (iconEl) iconEl.style.display = "flow-root";
        break;
      } else {
        const subEl = document.getElementById("sub" + item.id);
        const iconEl = document.getElementById("sub-icon" + item.id);
        if (subEl) subEl.style.border = "0";
        if (iconEl) iconEl.style.display = "none";
      }

      // Check rationale is filled (from Redux store, not DOM)
      const rationale = stored?.rationale?.trim() || "";

      if (!rationale) {
        valid = false;
        const mitigationEl = document.getElementById("mitigation" + item.id);
        if (mitigationEl) mitigationEl.style.border = "solid 1px red";
        break;
      } else {
        const mitigationEl = document.getElementById("mitigation" + item.id);
        if (mitigationEl) mitigationEl.style.border = "0";
      }

      // US-CAP-302: Evidence is mandatory for this question — block save until
      // at least one file has been attached (mirrors the severity/rationale checks above).
      const evidence = stored?.evidence || [];
      if (item.evidence_mandatory && evidence.length === 0) {
        valid = false;
        const evidenceEl = document.getElementById("evidence" + item.id);
        if (evidenceEl) evidenceEl.style.border = "solid 1px red";
        openNotification(
          "Evidence is required for one or more questions before saving. Please attach a file.",
          "error",
        );
        break;
      } else {
        const evidenceEl = document.getElementById("evidence" + item.id);
        if (evidenceEl) evidenceEl.style.border = "1px dashed #ccc";
      }

      // US-CAP-302: Strip any Mongo id (_id) that evidence items pick up once
      // they've round-tripped through the backend (e.g. after a reload) — the
      // submit payload should only carry the fields the API actually expects.
      const evidenceForPayload = evidence.map(({ id, _id, ...rest }) => rest);

      applicableSubControls.push({
        subcontrol: item.id,
        severity: severity,
        rational: rationale,
        question_type: stored?.question_type || "five_option",
        answer_value: stored?.answer_value || severity,
        evidence: evidenceForPayload,
      });
    }

    if (!valid) {
      setIsNotValidControl(true);
      setLoading(false);
      return;
    }

    // All safeguards validated — proceed with API submission
    const control =
      allControls[parseInt(document.getElementById("nextvalue").value) - 1];

    try {
      const assessment_id = urlparams.assessmentid;

      if (assessment_id) {
        let body = { assessment_id, applicableSubControls, control };
        let response = await submitAssessmentService(body);

        // US-CAP-301: The due date may have expired between page load and this
        // submit click — the backend responds 200 with onHold:true instead of
        // 201 in that case. Surface it clearly and stop, rather than silently
        // doing nothing (the old `if (response.status === 201)` would have).
        if (response?.data?.onHold) {
          setAssessmentStatus("On Hold");
          openNotification(
            response.data.message ||
              "This assessment is on hold because its due date has passed. Please contact your administrator to request an extension.",
            "error",
          );
          setLoading(false);
          return;
        }

        // US-CAP-302: Backend rejected the batch because mandatory evidence is
        // missing (e.g. an admin flipped evidence_mandatory=true after this page
        // loaded). Highlight the affected questions and stop.
        if (response?.status === 400) {
          (response?.data?.evidence_required_for || []).forEach(
            (subcontrolId) => {
              const evidenceEl = document.getElementById(
                `evidence${subcontrolId}`,
              );
              if (evidenceEl) evidenceEl.style.border = "solid 1px red";
            },
          );
          openNotification(
            response?.data?.message ||
              "Unable to save — please check the highlighted question(s).",
            "error",
          );
          setLoading(false);
          return;
        }

        if (!response) {
          openNotification(
            "Error while saving assessment. Please try again.",
            "error",
          );
          setLoading(false);
          return;
        }

        if (response.status === 201) {
          if (
            parseInt(document.getElementById("nextvalue").value) ===
            totalQuestions
          ) {
            if (isReject === true) {
              try {
                const body = {
                  assessment_id: urlparams.assessmentid,
                  status: "Submitted",
                };

                let response = await updateAssessmentService(body);

                if (response.status === 200 || response.status === 201) {
                  dispatch(clearSelfAssessment(urlparams.assessmentid));

                  navigate("/cap/completeassessment", {
                    state: {
                      assessmentid: urlparams.assessmentid,
                      standard: urlparams.standard,
                      status: urlparams.status,
                    },
                  });
                } else {
                  openNotification(
                    "Failed to update assessment status",
                    "error",
                  );
                }
              } catch (error) {
                openNotification("Permission denied or server error", "error");
              }
            } else {
              dispatch(clearSelfAssessment(urlparams.assessmentid));

              navigate("/cap/completeassessment", {
                state: {
                  assessmentid: urlparams.assessmentid,
                  standard: urlparams.standard,
                  status: urlparams.status,
                },
              });
            }
          } else {
            Next();
          }
        }
      }
    } catch (error) {
      openNotification("Error in submitting the assessment", "error");
    }

    setLoading(false);
  };

  // Fetches standards based on standard type and in case of retaking the assessment it sets the reject remarks
  const getSafeguards = async (id) => {
    let controlId = allControls[id];

    if (!controlId) {
      return;
    }
    try {
      let response = "";
      const companyId = selectedCompanyContainer.companyid;
      if (!companyId) return;
      response = await fetchSubControlsByCompanyStandardControlService({
        standardId,
        controlId,
        companyId,
      });

      if (response !== "") {
        let list = [];
        if (response.data.length > 0) {
          list = response.data;
          for (let i = 0; i < list.length; i++) {
            if (assementsList.length > 0) {
              assementsList.forEach((e) => {
                if (e.subcontrol === list[i].id) {
                  if (e.assessment_comments) {
                    list[i].assessment_comments = e.assessment_comments;
                  }
                }
              });
            }
          }
        }

        setSafeguards(list);
      }
    } catch (error) {
      openNotification("Error fetching standards", "error");
    }
  };

  // US-CAP-302: Evidence upload/removal for the self-assessment stage.
  // Supports multiple files per question; each capped at 2 MB (checked here
  // client-side for instant feedback, and again server-side as the source of truth).
  const EVIDENCE_MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB
  const EVIDENCE_SUPPORTED_TYPES = [
    "image/png",
    "image/jpeg",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/pdf",
    "text/plain",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "text/csv",
  ];
  const [evidenceUploading, setEvidenceUploading] = useState({});

  const handleEvidenceUpload = async (item, fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;

    const oversized = files.find((f) => f.size > EVIDENCE_MAX_FILE_SIZE_BYTES);
    if (oversized) {
      openNotification(
        `"${oversized.name}" exceeds the 2 MB limit per file.`,
        "error",
      );
      return;
    }
    const unsupported = files.find(
      (f) => !EVIDENCE_SUPPORTED_TYPES.includes(f.type),
    );
    if (unsupported) {
      openNotification(
        "Unsupported file type. Please upload PNG, JPG, JPEG, XLSX, PDF, TXT, DOC, DOCX, CSV or PPT files.",
        "error",
      );
      return;
    }

    setEvidenceUploading((prev) => ({ ...prev, [item.id]: true }));
    try {
      const formData = new FormData();
      formData.append("assessment_id", urlparams.assessmentid);
      formData.append("subcontrol", item.id);
      files.forEach((f) => formData.append("files", f));

      const response = await uploadSelfAssessmentEvidenceService(formData);
      if (response?.data?.evidence) {
        const existing = assessmentStore[item.id]?.evidence || [];
        const updated = [...existing, ...response.data.evidence];
        dispatch(
          saveSelfAssessment({
            assessmentId: urlparams.assessmentid,
            subcontrolId: item.id,
            field: "evidence",
            value: updated,
          }),
        );
        const evidenceEl = document.getElementById(`evidence${item.id}`);
        if (evidenceEl) evidenceEl.style.border = "0";
        openNotification("Evidence uploaded successfully.", "success");
      }
    } catch (error) {
      openNotification(
        error?.response?.data?.message || "Error while uploading evidence",
        "error",
      );
    } finally {
      setEvidenceUploading((prev) => ({ ...prev, [item.id]: false }));
    }
  };

  const handleEvidenceRemove = (item, key) => {
    const existing = assessmentStore[item.id]?.evidence || [];
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: item.id,
        field: "evidence",
        value: existing.filter((e) => e.key !== key),
      }),
    );
  };

  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  };

  // US-CAP-104: Handle answer changes for non-five_option question types
  // (yes_no, checkbox, radio, text_box)
  const handleAnswerChange = (item, newValue) => {
    const question_type = item.question_type || "five_option";

    // Map new answer to a legacy severity for backward compat
    const severity = mapAnswerToSeverity(question_type, newValue);

    // Update user.collection so saveStepByStep validation still works
    user.collection[item.id] = severity;

    // Persist to Redux store
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: item.id,
        field: "severity",
        value: severity,
      }),
    );
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: item.id,
        field: "answer_value",
        value: newValue,
      }),
    );
    dispatch(
      saveSelfAssessment({
        assessmentId: urlparams.assessmentid,
        subcontrolId: item.id,
        field: "question_type",
        value: question_type,
      }),
    );

    // For non-five_option types, open the rationale box automatically
    mitigationplus(item.id);
  };

  function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }

  // If the current control is present in the allcontrols set,the index is set to the current control id else it is set to the first control id
  const getLatestControl = () => {
    let flag = true;
    for (let index = 0; index < allControls.length; index++) {
      if (!assementsList.find((e) => e.control.includes(allControls[index]))) {
        latestControl(index);
        flag = false;
        break;
      }
    }

    if (flag) {
      latestControl(0);
    }
  };

  // Method fetches controls and safeguards based on control id
  const latestControl = async (controlId) => {
    try {
      await getControls(controlId);
      await getSafeguards(controlId);
      document.body.scrollTop = 200;
      document.documentElement.scrollTop = 200;
    } catch (error) {}
  };

  return (
    <div className="row py-2">
      <div>
        <div className="assessmenttitle">
          <div className="row py-2">
            <div className="col-10">
              <p className="mb-0">
                <img
                  src="../assets/icons/003-clipboard.svg"
                  className="new-assessment"
                  alt=""
                  draggable="false"
                />
                New assessment
                <ArrowRightIcon />
                {urlparams.standard === "CIS" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-cis.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "ISO-27001" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-iso-27001.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "NIST" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-nist.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "COBIT" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-cobit.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "TISAX" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-tisax.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "NIS 2.0" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-nis2.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "Ransomware" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-ransomware.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "Data Protection" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-data-protection.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {urlparams.standard === "Supplier Risk" && (
                  <img
                    className="px-sm standard-icon-size"
                    src="../assets/icons/standard-supplier-risk.png"
                    alt=""
                    draggable="false"
                  />
                )}
                {![
                  "TISAX",
                  "CIS",
                  "NIST",
                  "ISO-27001",
                  "COBIT",
                  "NIS 2.0",
                  "Ransomware",
                  "Data Protection",
                  "Supplier Risk",
                ].includes(urlparams.standard) && (
                  <GrCompliance className="px-sm standard-icon-size standard-img" />
                )}
                <span> {urlparams.standard} </span>
              </p>
            </div>
            <div className="col-2">
              <span
                className="backbutton"
                onClick={() => navigate("/cap/user-pendingassessments")}
              >
                <ArrowLeftIcon /> Back
              </span>
            </div>
          </div>
        </div>
        {loading && <LoadingOverlay />}
        {isOnHold && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "10px 20px",
              padding: "12px 16px",
              borderRadius: "6px",
              background: "#FFF4E5",
              border: "1px solid #FFB74D",
              color: "#7A4100",
            }}
          >
            <img
              src="../assets/icons/alert.svg"
              className="reject-icon"
              alt=""
              draggable="false"
            />
            <span>
              <strong>This assessment is on hold.</strong> Its due date
              {dueDate
                ? ` (${new Date(dueDate).toLocaleDateString()})`
                : ""}{" "}
              has passed, so answers can no longer be filled in or submitted.
              Please contact your administrator to request a due-date extension
              — your progress so far has been saved and will be available to
              continue as soon as the due date is extended.
            </span>
          </div>
        )}
        <div className="assessmentdiv">
          <div className="wrapper">
            <div className="steps" id="steps">
              <div className="row">
                <div className="col-2"></div>
                <div className="col-10 line">
                  <div className="stepdiv">
                    <p>
                      Step {question + 1}/{totalQuestions}
                    </p>
                  </div>
                  <div className="question">
                    {heading !== "" && <h3>{heading}</h3>}
                    {questionTitle && (
                      <h5>
                        <b>{questionTitle}</b>
                      </h5>
                    )}
                    <Button
                      className="prevvalueButton py-sm px-xl ml-sm my-sm"
                      variant="contained"
                      onClick={() => setDialog(true)}
                      id="prevvalueButton"
                      label="Help"
                      icon="arrow_back"
                    >
                      <QuizIcon />
                      Help
                    </Button>
                    <input
                      type="hidden"
                      id="nextvalue"
                      value={parseInt(question) + parseInt(1)}
                    />
                    {/* <div className="options">
                      <div className="spandiv">
                        <span className="na">NA</span>
                        <label>Not applicable</label>
                      </div>
                      <div className="spandiv">
                        <span className="ni">NI</span>
                        <label>Not implemented</label>
                      </div>
                      <div className="spandiv">
                        <span className="pi">PI</span>
                        <label>Partially implemented</label>
                      </div>
                      <div className="spandiv">
                        <span className="li">LI</span>
                        <label>Largely implemented</label>
                      </div>
                      <div className="spandiv">
                        <span className="fi">FI</span>
                        <label>Fully implemented</label>
                      </div>
                    </div> */}
                    <div className="options">
                      {standardOptions &&
                        Object.entries(standardOptions).map(([key, value]) => {
                          // Extract the uppercase letters from the key
                          const uppercaseKey =
                            key.match(/[A-Z]/g)?.slice(0, 2).join("") || "";
                          // Define color mapping based on score value
                          let color;
                          switch (value) {
                            case 0:
                              color = "#333333";
                              break;
                            case 1:
                              color = "#B60000";
                              break;
                            case 2:
                              color = "#BF9D12";
                              break;
                            case 3:
                              color = "#50E232";
                              break;
                            case 4:
                              color = "#227C10";
                              break;
                            default:
                              color = "#000000"; // Default color, in case value doesn't match any
                          }

                          return (
                            <div className="spandiv" key={value}>
                              <span
                                className="standardoption"
                                style={{ color }}
                              >
                                {uppercaseKey}
                              </span>
                              <label>{key}</label>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>

              <div id="fixeddiv">
                {/* ===== Mandatory Note - Code change ===== **/}
                <div className="row">
                  <div className="col-2"></div>

                  <div className="row col-10 line">
                    <div style={{ margin: "5px", width: "95%" }}>
                      <p
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          color: "#B60000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                      >
                        All fields are mandatory to fill
                      </p>
                    </div>
                  </div>
                </div>
                {safeguards.length > 0 &&
                  safeguards.map((item, index) => (
                    <div className="row" key={item.id}>
                      <div className="col-2">
                        {heading === "" && (
                          <p className="title titlediv">{questionTitle}</p>
                        )}
                        {heading !== "" && (
                          <p className="title titlediv">{heading}</p>
                        )}
                      </div>
                      <div className="row col-10 line" id={`main${item.id}`}>
                        <div
                          className="row"
                          id={`sub${item.id}`}
                          style={{ margin: "5px", width: "95%" }}
                        >
                          <div className="col-7 question-block">
                            <div className="step">
                              <div className="number">{index + 1}</div>
                              <div className="info">
                                <p className="text">
                                  {item.SubControlName && !item.Question && (
                                    <span>{item.SubControlName}</span>
                                  )}
                                  {item.Question && (
                                    <span>{item.Question}</span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-5 question-block">
                            <div>
                              <Dialog
                                open={dialog}
                                onClose={() => setDialog(false)}
                                aria-labelledby="delete-dialog-title"
                                BackdropProps={{
                                  style: {
                                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                                  },
                                }}
                              >
                                <DialogTitle align="center">
                                  <QuizIcon
                                    fontSize="large"
                                    style={{ color: blueGrey }}
                                  />
                                  Rating Criteria
                                  {/* Added X Mark Code Start */}
                                  <IconButton
                                    aria-label="close"
                                    onClick={() => setDialog(false)}
                                    sx={{
                                      position: "absolute",
                                      right: 8,
                                      top: 8,
                                      color: (theme) => theme.palette.grey[500],
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                  {/* Added X Mark Code End */}
                                </DialogTitle>
                                <DialogContent>
                                  <ul>
                                    <li>
                                      <strong>Not Applicable (0):</strong> This
                                      rating is given when a specific process is
                                      not applicable to the organization or the
                                      assessed scope. In other words, the
                                      process does not exist or is not relevant
                                      to the context being evaluated.
                                    </li>
                                    <li>
                                      <strong>Not Implemented (1):</strong> This
                                      rating is assigned when the process is
                                      recognized as necessary but has not been
                                      implemented or addressed adequately. The
                                      organization has made minimal efforts, if
                                      any, to establish the process, resulting
                                      in its absence or neglect.
                                    </li>
                                    <li>
                                      <strong>
                                        Partially Implemented (2):
                                      </strong>{" "}
                                      This rating indicates that the process has
                                      been implemented to some extent but falls
                                      short of being fully integrated within the
                                      organization. Typically, this rating
                                      covers a range of 15 to 50% of the
                                      required implementation.
                                    </li>
                                    <li>
                                      <strong>Largely Implemented (3):</strong>{" "}
                                      This rating represents a significantly
                                      higher level of process implementation
                                      compared to the previous rating. Processes
                                      receiving this rating are largely
                                      established and practiced within the
                                      organization, covering approximately 50 to
                                      85% of the required implementation.
                                    </li>
                                    <li>
                                      <strong>Fully Implemented (4):</strong>{" "}
                                      The highest rating signifies that the
                                      process is fully implemented and
                                      consistently followed throughout the
                                      organization. This rating is assigned when
                                      the process has been successfully
                                      integrated and adhered to in at least 85%
                                      of the required implementation.
                                    </li>
                                  </ul>
                                </DialogContent>
                              </Dialog>
                            </div>
                            <div id={item.id}>
                              {/* US-CAP-104: QuestionRenderer handles all 5 question types.
                                  For five_option, it internally uses the spanActive DOM approach for backward compat.
                                  For all other types, it uses React-controlled onChange. */}
                              <QuestionRenderer
                                question_type={
                                  item.question_type || "five_option"
                                }
                                answer_config={item.answer_config || null}
                                value={
                                  assessmentStore[item.id]?.answer_value ||
                                  assessmentStore[item.id]?.severity ||
                                  undefined
                                }
                                readOnly={isOnHold}
                                standardOptions={standardOptions}
                                itemId={item.id}
                                onSpanActive={spanActive}
                                index={index}
                                onChange={(newValue) =>
                                  handleAnswerChange(item, newValue)
                                }
                              />

                              {/* US-CAP-302: Evidence upload — attached at the self-assessment stage.
                                  clear:'both' + width:'100%' is required here because .optionsline
                                  (the five_option pill row) is float:left in cap.css — without clearing
                                  it, this block gets squeezed into the leftover space beside the pills
                                  instead of dropping to a full-width row below them. */}
                              <div
                                id={`evidence${item.id}`}
                                style={{
                                  clear: "both",
                                  width: "100%",
                                  boxSizing: "border-box",
                                  marginTop: 14,
                                  padding: 10,
                                  border: "1px dashed #ccc",
                                  borderRadius: 4,
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    marginBottom: 6,
                                  }}
                                >
                                  Evidence
                                  {item.evidence_mandatory && (
                                    <span style={{ color: "#B71C1C" }}>
                                      {" "}
                                      * required
                                    </span>
                                  )}
                                  {!item.evidence_mandatory && (
                                    <span
                                      style={{ color: "#888", fontWeight: 400 }}
                                    >
                                      {" "}
                                      (optional)
                                    </span>
                                  )}
                                </div>

                                {/* Browse button first, uploaded files listed below it */}
                                {!isOnHold && (
                                  <div>
                                    <input
                                      type="file"
                                      multiple
                                      disabled={evidenceUploading[item.id]}
                                      onChange={(e) => {
                                        handleEvidenceUpload(
                                          item,
                                          e.target.files,
                                        );
                                        e.target.value = "";
                                      }}
                                      accept=".png,.jpg,.jpeg,.xlsx,.pdf,.txt,.doc,.docx,.ppt,.pptx,.csv"
                                    />
                                    <div
                                      style={{
                                        fontSize: 11,
                                        color: "#888",
                                        marginTop: 2,
                                      }}
                                    >
                                      Multiple files allowed · 2 MB max per file
                                    </div>
                                    {evidenceUploading[item.id] && (
                                      <div
                                        style={{
                                          fontSize: 11,
                                          color: "#1565C0",
                                        }}
                                      >
                                        Uploading…
                                      </div>
                                    )}
                                  </div>
                                )}

                                {(assessmentStore[item.id]?.evidence || [])
                                  .length > 0 && (
                                  <div style={{ marginTop: 8 }}>
                                    {(
                                      assessmentStore[item.id]?.evidence || []
                                    ).map((file) => (
                                      <div
                                        key={file.key}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          gap: 8,
                                          fontSize: 12,
                                          padding: "4px 0",
                                          borderTop: "1px solid #eee",
                                        }}
                                      >
                                        <span
                                          style={{
                                            flex: "1 1 auto",
                                            minWidth: 0,
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          📎 {file.filename}{" "}
                                          <span style={{ color: "#888" }}>
                                            ({formatFileSize(file.size)})
                                          </span>
                                        </span>
                                        {!isOnHold && (
                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleEvidenceRemove(
                                                item,
                                                file.key,
                                              )
                                            }
                                            style={{
                                              flex: "0 0 auto",
                                              border: "none",
                                              background: "none",
                                              color: "#B71C1C",
                                              cursor: "pointer",
                                              fontSize: 12,
                                            }}
                                          >
                                            Remove
                                          </button>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-7 question-block">
                            {item.assessment_comments !== undefined && (
                              <div>
                                <p className="text">
                                  <span className="reject-remarks">
                                    {" "}
                                    Reject remarks :{" "}
                                  </span>{" "}
                                  <span className="reject-remarks">
                                    {item.assessment_comments}
                                  </span>
                                </p>
                              </div>
                            )}
                            <div
                              className="mitigationdiv"
                              id={`mitigation${item.id}`}
                            >
                              <div
                                className="mitigationplus"
                                onClick={() => mitigationplus(item.id)}
                              >
                                Rationale <ArrowDownwardIcon />
                              </div>
                              <div
                                className="mitigationminus"
                                onClick={() => mitigationminus(item.id)}
                              >
                                Rationale <ArrowUpwardIcon />
                              </div>
                              <div className="mitigationtextarea">
                                <div className="row col-12 mt-2">
                                  <textarea //TE for data persistence this block editing start
                                    className="mit1"
                                    value={
                                      assessmentStore[item.id]?.rationale || ""
                                    }
                                    onChange={
                                      (e) =>
                                        //TE for Proper data store following block of code commented for follow code
                                        // dispatch(
                                        //   saveSelfAssessment({
                                        //     subcontrolId: item.id,
                                        //     field: "rationale",
                                        //     value: e.target.value,
                                        //   })
                                        // )
                                        //TE for Proper data store start
                                        dispatch(
                                          saveSelfAssessment({
                                            assessmentId:
                                              urlparams.assessmentid,
                                            subcontrolId: item.id,
                                            field: "rationale",
                                            value: e.target.value,
                                          }),
                                        )
                                      //TE for Proper data store end
                                    }
                                    placeholder="Rationale for rating"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-5 question-block">
                            {/* <div
                              className="confusion"
                              id={`question${item.id}`}
                            >
                              <span
                                onClick={() => viewmore(item.id)}
                                className="down"
                              >
                                Need more guidance? <ArrowDownwardIcon />
                              </span>
                              <span
                                onClick={() => viewless(item.id)}
                                className="up"
                              >
                                Need more guidance? <ArrowUpwardIcon />
                              </span>
                            </div> */}
                            <div
                              className="confusion_answer"
                              id={`answer${item.id}`}
                            >
                              <div className="so-accordion-wrapper">
                                <div className="so-tab">
                                  <input
                                    id={`so-tab-1${item.id}`}
                                    type="checkbox"
                                    name="tabs"
                                  />{" "}
                                  <label htmlFor={`so-tab-1${item.id}`}>
                                    Not applicable
                                  </label>
                                  <div className="so-tab-content">
                                    <p>{item.NotApplicable}</p>
                                  </div>
                                </div>
                                <div className="so-tab">
                                  <input
                                    id={`so-tab-2${item.id}`}
                                    type="checkbox"
                                    name="tabs"
                                  />{" "}
                                  <label htmlFor={`so-tab-2${item.id}`}>
                                    Not implemented
                                  </label>
                                  <div className="so-tab-content">
                                    <p>{item.NotImplemented}</p>
                                  </div>
                                </div>

                                <div className="so-tab">
                                  <input
                                    id={`so-tab-3${item.id}`}
                                    type="checkbox"
                                    name="tabs"
                                  />{" "}
                                  <label htmlFor={`so-tab-3${item.id}`}>
                                    Partially implemented
                                  </label>
                                  <div className="so-tab-content">
                                    <p>{item.PartiallyImplemented}</p>
                                  </div>
                                </div>
                                <div className="so-tab">
                                  <input
                                    id={`so-tab-4${item.id}`}
                                    type="checkbox"
                                    name="tabs"
                                  />{" "}
                                  <label htmlFor={`so-tab-4${item.id}`}>
                                    Largely implemented
                                  </label>
                                  <div className="so-tab-content">
                                    <p>{item.LargelyImplemented}</p>
                                  </div>
                                </div>
                                <div className="so-tab">
                                  <input
                                    id={`so-tab-5${item.id}`}
                                    type="checkbox"
                                    name="tabs"
                                  />{" "}
                                  <label htmlFor={`so-tab-5${item.id}`}>
                                    Fully implemented
                                  </label>
                                  <div className="so-tab-content">
                                    <p>{item.FullyImplemented}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id={`sub-icon${item.id}`}
                          style={{ width: "5%", display: "none" }}
                        >
                          <img
                            src="../assets/icons/alert.svg"
                            style={{ width: "20px" }}
                            alt=""
                            draggable="false"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              {/* 🔽 ADD REJECTION SUMMARY HERE */}
              {assessmentStatus?.toLowerCase().includes("reject") &&
                rejectionSummary && (
                  <div className="row mt-3">
                    <div className="col-2"></div>

                    <div className="col-10">
                      <div style={{ marginTop: "10px" }}>
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#B60000",
                            marginBottom: "5px",
                          }}
                        >
                          Rejection summary given by admin:
                        </div>

                        <div style={{ color: "#444" }}>{rejectionSummary}</div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="col">
        {isPrevvalueButton && (
          <button
            className="prevvalueButton py-sm px-xl ml-sm my-sm"
            onClick={() => Prev()}
            id="prevvalueButton"
            label="Previous"
            icon="arrow_back"
          >
            <ArrowLeftIcon />
            Previous
          </button>
        )}
        {isNotValidControl === true && (
          <span className="validation-block">
            <img
              src="../assets/icons/alert.svg"
              className="reject-icon"
              alt=""
              draggable="false"
            />
            <label className="reject-remarks">
              Oops! fill all the options before proceeding to the next step
            </label>
          </span>
        )}
        {isNextValueButton && (
          <button
            className="nextvalueButton py-sm px-xl ml-sm my-sm"
            onClick={() => !isOnHold && saveStepByStep()}
            id="nextvalueButton"
            label="Save & Next"
            disabled={isOnHold}
            style={
              isOnHold ? { opacity: 0.5, cursor: "not-allowed" } : undefined
            }
          >
            Save & next <ArrowRightIcon />
          </button>
        )}
        {isSaveButton && (
          <button
            className="saveButton py-sm px-xl ml-sm my-sm"
            onClick={() => !isOnHold && saveStepByStep()}
            id="SaveButton"
            label="Submit your Assessment"
            disabled={isOnHold}
            style={
              isOnHold ? { opacity: 0.5, cursor: "not-allowed" } : undefined
            }
          >
            Submit your assessment
          </button>
        )}
      </div>
    </div>
  );
};

export default SelfAssessmentPage;
